import request from '@/api/request'
import {
  Res,
  ResWithMeta,
  StarListReq,
  InfluencersStarListRes,
  VideoStarListRes,
  ProductStarListRes,
  LivesStarListRes,
  ShopStartListRes,
  FavoritesCount,
  createGroupReq,
  GroupListItemRes,
  CollectionGroupRes
} from '@/types/api'
import type { AxiosRequestConfig } from 'axios'

export const starVideoApi = (id: string) => {
  return request.post<Res>(`/data/videos/${id}/star`)
}

export const unStarVideoApi = (id: string) => {
  return request.delete<Res>(`/data/videos/${id}/unstar`)
}

export const getVideoStarListApi = (params: StarListReq) => {
  return request.get<ResWithMeta<VideoStarListRes>>('/data/videos/star/list', { params })
}

export const starInfluencerApi = (id: string) => {
  return request.post<Res>(`/data/influencers/${id}/star`)
}

export const unStarInfluencerApi = (id: string) => {
  return request.delete<Res>(`/data/influencers/${id}/unstar`)
}

export const getInfluencerStarListApi = (params: StarListReq) => {
  return request.get<ResWithMeta<InfluencersStarListRes>>('/data/influencers/star/list', { params })
}

export const starProductApi = (id: string) => {
  return request.post<Res>(`/data/products/${id}/star`)
}

export const unStarProductApi = (id: string) => {
  return request.delete<Res>(`/data/products/${id}/unstar`)
}

export const getProductStarListApi = (params: StarListReq) => {
  return request.get<ResWithMeta<ProductStarListRes>>('/data/products/star/list', { params })
}

export const starLiveApi = (id: string) => {
  return request.post<Res>(`/data/lives/${id}/star`)
}

export const unStarLiveApi = (id: string) => {
  return request.delete<Res>(`/data/lives/${id}/unstar`)
}

export const getLiveStarListApi = (params: StarListReq) => {
  return request.get<ResWithMeta<LivesStarListRes>>('/data/lives/star/list', { params })
}

export const starShopApi = (id: string) => {
  return request.post<Res>(`/data/seller/${id}/star`)
}

export const unStarShopApi = (id: string) => {
  return request.delete<Res>(`/data/seller/${id}/unstar`)
}

export const getShopStarListApi = (params: StarListReq) => {
  return request.get<ResWithMeta<ShopStartListRes>>('/data/seller/star/list', { params })
}

export const getCountApi = () => {
  return request.get<ResWithMeta<FavoritesCount>>('/users/collections/stats')
}

// 获取列表
export const getGroupListApi = () => {
  return request.get<Res<CollectionGroupRes>>('/collection-group/list')
}

// 创建分组
export const createGroupApi = (params: createGroupReq) => {
  return request.post<Res>(`/collection-group/create`, params)
}

// 更新分组
export const updateGroupApi = ({ id, name }: { id: string; name: string }) => {
  return request.post<Res>(`/collection-group/update/${id}`, { name })
}

// 分组置顶
export const setTopGroupApi = (id: string) => {
  return request.get<Res>(`/collection-group/set-top/${id}`)
}

// 移动分组
export const moveGroupApi = ({ id, group_id }: { id: string; group_id: string }) => {
  return request.put<Res>(`/collection-group/move-data/${id}`, { group_id })
}

// 删除分组
export const deleteGroupApi = (id: string) => {
  return request.delete<Res>(`/collection-group/delete/${id}`)
}
